import Navbar from '../components/NavbarDashboard';
import NavbarMobile from '../components/NavbarDashboardMobile';
import styles from '../styles/Dashboard.module.css';
import {
  auth,
  firestore,
  serverTimestamp,
  toMillis,
  arrayUnion,
} from '../lib/firebase';
import { UserContext } from '../lib/context';
import { useRouter } from 'next/router';
import { useState, useEffect, useContext, useRef, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Head from 'next/head';

export default function Chat() {
  // Process
  useEffect(() => {
    console.log('==============');
    console.log(process.env.NODE_ENV);
  }, []);
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, user-scalable=0"
        />
      </Head>
      <Navbar />
      <Body />
    </>
  );
}

function Body() {
  const router = useRouter();
  const { user } = useContext(UserContext);
  const [stateLoaded, setStateLoaded] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [chats, setChats] = useState(false);
  const [text, setText] = useState('');

  // Load chats
  useEffect(() => {
    if (user) {
      setLoading(true);

      const unsubscribe = firestore
        .collection('chats')
        .where('userID', '==', user.uid)
        .orderBy('createdAt', 'asc') // Sort by timestamp
        .limitToLast(20) // Only retrieve the last 20 messages
        .onSnapshot((querySnapshot) => {
          const chatsArr = [];
          querySnapshot.forEach((doc) => {
            const id = doc.id;
            const data = doc.data();
            // Add docId and chat data to chats array
            chatsArr.push({ id, ...data });
          });
          setChats(chatsArr);

          setLoading(false);
        });

      return () => {
        unsubscribe();
        setLoading(false);
      };
    }
  }, [user]);

  // Log chats
  useEffect(() => {
    if (chats) {
      console.log(user.uid);
      console.log(chats);
      scroll();
    }
  }, [chats]);

  // State Loaded
  useEffect(() => {
    if (user && chats) {
      setStateLoaded(true);
    }
  }, [user, chats]);

  const handleKeypress = (e) => {
    //it triggers by pressing the enter key

    if (e.keyCode === 13 || e.which === 13) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setSendLoading(true);

    // Dont allow empty/large messages
    if (text.length > 1 && text.length < 500) {
      try {
        const newMsg = {
          createdAt: serverTimestamp(),
          content: text,
          userID: user.uid,
          sentBy: user.uid,
        };

        const userData = {
          lastChat: true,
          lastChatAt: serverTimestamp(),
        };

        setText('');
        await firestore.collection('chats').doc().set(newMsg);
        await firestore.collection('users').doc(user.uid).update(userData);
      } catch (err) {
        console.log(err);
      }
      setSendLoading(false);
    }
  };
  const modelRef = useRef(null);
  const wrapper = useCallback((node) => {
    modelRef.current = node;
    scroll();
    // node.scrollIntoView({ behavior: 'smooth' });
    // console.log('REF');
    // console.log(node);
  }, []);

  const scroll = () => {
    // console.log('REF');
    // console.log(modelRef.current);
    modelRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });
  };

  return (
    <div className={`${styles['dashboard-container']} red`}>
      <div className={`${styles['dashboard-container-max']} red`}>
        <div className={`${styles['dashboard-item-title']} red`}>Chat</div>
        {!stateLoaded && (
          <div className={`${styles['prescriptions-item-container']} red`}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </div>
        )}
        {stateLoaded && chats.length == 0 && (
          <div className={`${styles['prescriptions-item-container']} red`}>
            Send a message to our medical team if you have any questions.
          </div>
        )}

        {stateLoaded && chats.length > 0 && (
          <div
            id="chat"
            className={`${styles['chat-container-container']} red`}
          >
            {chats.map((chat, i) => (
              <Message chat={chat} Key={i} />
            ))}
            <div ref={wrapper} />
          </div>
        )}

        {/* INPUT */}
        {/* INPUT */}
        {/* INPUT */}
        <div className={`${styles['chat-input-container']} red`}>
          <textarea
            className={`${styles['chat-input-field1']} red`}
            placeholder="Enter a message..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyPress={handleKeypress}
          />
          <button
            className={
              text.length == 0 || sendLoading
                ? `${styles['chat-input-btn2']} red`
                : `${styles['chat-input-btn-active2']} red`
            }
            onClick={handleSubmit}
            disabled={text.length == 0 || sendLoading ? true : false}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
            </svg>
          </button>
        </div>

        <NavbarMobile />
      </div>
    </div>
  );
}

function Message({ chat }) {
  return (
    <>
      {chat.userID !== chat.sentBy ? (
        <div className={`${styles['chat-container']} red`}>
          <div className={`${styles['chat-msg-container']} red`}>
            {chat.content}
          </div>
          <div className={`${styles['chat-timestamp-container']} red`}>
            {`${new Date(chat.createdAt?.toMillis())
              .toString()
              .slice(16, 21)} (${new Date(chat.createdAt?.toMillis())
              .toString()
              .slice(4, 10)})`}
          </div>
        </div>
      ) : (
        <div className={`${styles['chat-container']} red`}>
          <div className={`${styles['chat-msg-container-other']} red`}>
            {chat.content}
          </div>
          <div className={`${styles['chat-timestamp-container-other']} red`}>
            {`${new Date(chat.createdAt?.toMillis())
              .toString()
              .slice(16, 21)} (${new Date(chat.createdAt?.toMillis())
              .toString()
              .slice(4, 10)})`}
          </div>
        </div>
      )}
    </>
  );
}
